



















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import FormRange from '@/components/form/formrange';
import ExtButton from '@/components/ext/Button.vue';
import { fullArrayDefault } from '@/tools/fullarray';
import { Questions } from './types';

@Component({
  components: {
    FormRange,
    ExtButton,
  }
})
export default class ComponentsAnketa extends Vue {
  @Prop({type: String, default: ''})
  description: string;

  @Prop({type: Array, default: null})
  questions: Questions;

  @Prop({type: Number, default: 5})
  defaultPosition: number;

  formAnswers: Array<number> = [];
  warning: boolean = false;
  submitPermition: boolean = false;

  get btnText() {
    return this.warning ? 'Сделайте выбор' : 'Готово';
  }

  @Watch('formAnswers', { immediate: true })
  isChangeSliderPos(value: any, oldValue: any) {
    if (value === oldValue) {
      this.submitPermition = true;
      this.warning = false;
    }
  }

  @Watch('questions', { immediate: true })
  isQuestionsChange() {
    const { defaultPosition, questions } = this;
    this.formAnswers = fullArrayDefault(questions.length, defaultPosition);
  }

  submit() {
    const { formAnswers, questions, submitPermition } = this;
    const result = formAnswers.map((items, index) => {
      return {
        question_id: parseInt(questions[index].id, 10),
        value: items
      };
    });
    if (submitPermition) {
      this.$emit('submit', {
        form_id: parseInt(questions[0].form_id, 10),
        values: result,
      });
    } else {
      this.warning = true;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/anketa/Anketa.vue